"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildSyncResolvedParams = BuildSyncResolvedParams;
function BuildSyncResolvedParams(params) {
    return params;
}
